// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1B2TE","info":"Note_info__1inUS","note":"Note_note__N7u03","actions":"Note_actions__2NO4k"};